import { ServiceBusEnum } from "../../api-client-nswag/taxportal-client";

export const IR_ROLLOVERS = [typeof ServiceBusEnum.IR_ROLLOVER];
export const FILES_ROLLOVERS = [typeof ServiceBusEnum.FILES_ROLLOVER];

export const FILES_TYPE = "Files";

export const SERVICE_OPTIONS = {
  SCHEDULE: "schedule",
  INSER_TOPIC: "insert topic",
  CANCEL_SCHEDULE: "cancel",
  ROLLOVER_NOW: "rollover now",
};

export const PAGE_CAPTIONS = {
  ROLLOVER_PAGE_TITLE: "Make a selection to begin rollover",
  MODAL_TITLE: 'Submit Rollover Request?', //"Are you sure you want to continue?",
  GRID_TITLE: "Rollover History",
  USER: "User",
  TYPE: "Type",
  TAX_YEAR: "Tax Year",
  NEW_TAX_YEAR: "New Tax Year",
  ROLOVER_REQUESTED_DATE: "Rollover Requested Date",
  ROLOVER_SCHEDULED_DATE: "Scheduled Date",
  ROLLOVER_DATE: "Rollover Date",
  STATUS: "Status",
  STATUS_DETAILS: "Status Details",
  EXECUTION_DETAILS: "Execution Details",
  FILES: "Files",
  RETRY: "Retry",
  CANCEL_SCHEDULED: "Cancel Process",
  CANCELED_BY: "Canceled By",
  CANCELED_DATE: "Canceled Date",
  NOTIFICATION_SENT: "Notifications Sent",
  FIRST_NOTIFICATION_SENT: "First Notification Sent",
  SECOND_NOTIFICATION_SENT: "Second Notification Sent",
};

export const ROLLOVER_OPTIONS: { [key: string]: string } = {
  INFORMATION_REQUEST: "Information Request",
  PROJECT_TRACKING: "Project Tracking",
  FILES: "Files",
  DELIVERABLES: "Deliverables",
  K1TRACKER: "K1 Tracker"
};

export const ROLLOVER_STATUSES = {
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
  PARTIALLY_SUCCESS: "PARTIALLYSUCCESS"
};

export const SITE_ROLLOVER_COMPLETION = "SITEROLLOVERCOMPLETION";
export const SITE_ROLLOVER_COMPLETION_DISPLAY = "Site_rollover_completion";

export const NOTIFICATION_MESSAGES = {
  OPENING_MESSAGE: "If you continue, rollover is not reversible.",
  INFORMATION_REQUEST_MSG: " The Information Request list will be rolled forward.",
  PROJECT_TRACKING_MSG: " Project Tracking list will be rolled forward.",
  DELIVERABLES_MSG: "Deliverables will be rolled forward.",
  K1TRACKER_MSG: "K1 Tracker will be rolled forward.",
  FILES_MSG_1: " Files will be removed from Tax Portal in %days% days.",
  FILES_MSG_2: " Clients will be notified via email if you continue.",
  FILES_MSG_3_CS: " Files will be removed",
  CLOSING_MESSAGE: "Select 'Continue' to proceed or 'Cancel' to close.",
  DEFAULT_SCHEDULE_DAYS: 1,
};

// Rollover Submit Modal Configuration
export interface RolloverSubmitModalConfig {
  entityName: string;
  messageTemplate: string;
}

export const ROLLOVER_SUBMIT_MODAL = {
  TITLE: "Submit Rollover Request?",
  CLOSING_MESSAGE: "Select 'Continue' to proceed or 'Cancel' to close.",
  CANCEL_BUTTON: "Cancel",
  CONTINUE_BUTTON: "Continue",
};

// =====================================================
// ROLLOVER SUBMIT MESSAGE TEMPLATES
// Each rollover type has its own message template.
// Use %days% as placeholder for dynamic days value.
// Modify individual templates below as needed.
// =====================================================

export const ROLLOVER_MESSAGE_TEMPLATES = {
    FILES: "Files will be removed from Tax Portal on %scheduledDate%. Clients will be notified based on the notification preferences.",
  
    INFORMATION_REQUEST: "Information Request records will be removed from Tax Portal on %scheduledDate%.",

    PROJECT_TRACKING: "Project Tracking records will be removed from Tax Portal on %scheduledDate%.",

    DELIVERABLES: "Deliverables records will be removed from Tax Portal on %scheduledDate%.",
  
    K1TRACKER: "K1 Tracker records will be removed from Tax Portal on %scheduledDate%.",
};

// Default days value when not provided
export const DEFAULT_ROLLOVER_DAYS = 30;

// Configuration mapping for each rollover type
export const ROLLOVER_SUBMIT_MESSAGES: { [key: string]: RolloverSubmitModalConfig } = {
  FILES: {
    entityName: "Files",
    messageTemplate: ROLLOVER_MESSAGE_TEMPLATES.FILES,
  },
  INFORMATION_REQUEST: {
    entityName: "Information Request",
    messageTemplate: ROLLOVER_MESSAGE_TEMPLATES.INFORMATION_REQUEST,
  },
  PROJECT_TRACKING: {
    entityName: "Project Tracking",
    messageTemplate: ROLLOVER_MESSAGE_TEMPLATES.PROJECT_TRACKING,
  },
  DELIVERABLES: {
    entityName: "Deliverables",
    messageTemplate: ROLLOVER_MESSAGE_TEMPLATES.DELIVERABLES,
  },
  K1TRACKER: {
    entityName: "K1 Tracker",
    messageTemplate: ROLLOVER_MESSAGE_TEMPLATES.K1TRACKER,
  },
};

// Helper function to replace %days% and %scheduledDate% placeholders
const replacePlaceholders = (template: string, days?: number, scheduledDate?: string): string => {
  let result = template;
  if (days !== undefined) {
    result = result.replace(/%days%/g, days.toString());
  }
  if (scheduledDate) {
    result = result.replace(/%scheduledDate%/g, scheduledDate);
  }
  return result;
};

// Updated helper function to get the submit modal message based on rollover type
export const getRolloverSubmitMessage = (
  rolloverType: string,
  days?: number,
  scheduledDate?: string
): { entityName: string; message: string } => {
  const config = ROLLOVER_SUBMIT_MESSAGES[rolloverType];
  const daysValue = days ?? DEFAULT_ROLLOVER_DAYS;

  if (config) {
    return {
      entityName: config.entityName,
      message: replacePlaceholders(config.messageTemplate, daysValue, scheduledDate),
    };
  }

  // Default fallback to FILES configuration
  return {
    entityName: ROLLOVER_SUBMIT_MESSAGES.FILES.entityName,
    message: replacePlaceholders(ROLLOVER_SUBMIT_MESSAGES.FILES.messageTemplate, daysValue, scheduledDate),
  };
};
